import React, { useContext, useState } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { Context } from '@components/Context';
import { useShoppingContext } from '@components/products/ProductShoppingContext';
import Colors from '@components/shared/Colors';
import { BoxState, CartItemType, PadsBoxStackState, PadsBoxState, Prices, ProductCodeKey } from '@contracts';
import { createCartItem } from '@utils/cart';
import AddToCart from './AddToCart';
import QuantityAddToCart from './QuantityAddToCart';

interface Props {
  id: string;
  productCode: ProductCodeKey;
  price: number;
  showQuantity?: boolean;
  prices?: Prices;
  boxState?: BoxState | PadsBoxState | PadsBoxStackState;
}

const CheckoutQuantitySelector: React.FC<Props> = ({ productCode, price, showQuantity = true, prices = {}, boxState }) => {
  const { t } = useTranslation();
  const { state } = useContext(Context);
  const { currency } = state;
  const [quantity, setQuantity] = useState(1);
  const { selectedAddonCartItems } = useShoppingContext();

  const renderPriceText = () => {
    if (price < 0) return '';
    if (price === 0) return t('components.free');
    return `${currency.symbol}${(price * quantity)?.toFixed(2)}`;
  };

  return (
    <Container>
      <PriceSection>
        {showQuantity && (
          <QuantityAddToCart
            quantity={quantity}
            onAdd={() => setQuantity(quantity + 1)}
            onRemove={() => setQuantity(quantity - 1)}
          ></QuantityAddToCart>
        )}
        <Price>{renderPriceText()}</Price>
      </PriceSection>
      <AddToCartStyled
        cartItem={createCartItem(productCode, quantity, price, showQuantity, CartItemType.OneOffPurchase, prices, boxState)}
        addonCartItems={selectedAddonCartItems}
      />
    </Container>
  );
};

export default CheckoutQuantitySelector;

interface StyleProps {
  textColor?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const PriceSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  background: ${Colors.cream};
  border: 1px solid ${Colors.ecru};
  box-sizing: border-box;
  border-radius: 2px 2px 0 0;
`;

const Price = styled.div`
  width: 100%;
  font-family: Domaine;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  text-transform: capitalize;
  color: ${(props: StyleProps) => props.textColor};
`;

const OldPrice = styled(Price)`
  text-decoration: line-through;
  color: ${Colors.red};
`;

const AddToCartStyled = styled(AddToCart)`
  width: 100%;
  border-radius: 0 0 2px 2px;
  color: ${Colors.cream};
`;
